import type { IconData } from '@stacksjs/iconify-core'

export const qa4x3: IconData = {
  "body": "<path fill=\"#8d1b3d\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 0v480h158.4l97.8-26.7l-97.8-26.6l97.7-26.7l-97.7-26.7l97.7-26.6l-97.7-26.7l97.8-26.7l-97.8-26.6l97.7-26.7l-97.7-26.7l97.7-26.6l-97.7-26.7l97.8-26.7l-97.8-26.6L256.1 80l-97.7-26.7l97.8-26.6L158.3 0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default qa4x3
